export enum CalendarDayType {
  PreviousMonth = 'previous-month',
  CurrentMonth = 'current-month',
  NextMonth = 'next-month',
}

export interface CalendarMonth {
  year: number;
  name: string;
  anchor: string;
  weekdays: string[];
  grid: CalendarDay[][];
  isFromNextYear: OptionalBoolean;
}

export interface CalendarDay {
  value: number;
  date: Date;
  week: number;
  type: CalendarDayType;
  isToday: boolean;
  isWeekend: boolean;
  identifier: string;
  iso: string;
  formatted: string;
  visible: boolean;
  disabled: OptionalBoolean;
  selected: OptionalBoolean;
  dayInRange: OptionalBoolean;
  dayInRangeRight: OptionalBoolean;
  dayInRangeLeft: OptionalBoolean;
}

type OptionalBoolean = boolean | null | undefined;
